import { z } from 'zod/v4';

export const RequestCompanyDocumentAccessParamsSchema = z.object({
  id: z.string().min(1),
});

export type RequestCompanyDocumentAccessParams = z.infer<
  typeof RequestCompanyDocumentAccessParamsSchema
>;
